import React from "react";
import uploadIcon from "../../assets/images/upload.png";
import { toast } from "react-toastify";
import { uploadBanner } from "../../api/uploadMedia";


const ImageUpload = ({ setImage }) => {
  const onFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 83886080) {
        toast.error("File size must be less than 80 MB.", {
          position: "top-center",
          autoClose: 5000,
        });
      } else {

        const timestamp = Date.now();
        const fileExtension = file.name.split(".").pop();
        const finalFileName = `banner_${timestamp}.${fileExtension}`;
        const renamedFile = new File([file], finalFileName, { type: file.type });
        const response = await uploadBanner(renamedFile, finalFileName);

        if (response.status === 201) {
          setImage(response.data.url);

          toast.success("Your banner was uploaded successfully!", {
            position: "top-center",
            autoClose: 5000,
          });
        } else {
          toast.error("Something went wrong! Please try again later", {
            position: "top-center",
            autoClose: 5000,
          });
        }
      }
    }
  }

  return (
    <div
      className="border mb-1 hover-shadow d-flex justify-content-center align-items-center"
      style={{
        borderRadius: "8px",
        borderColor: "#ccc",
        borderWidth: "2px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100px", // Adjust as needed
      }}
    >
      <label htmlFor="jsonFile" style={{ height: "100px", cursor: "pointer" }}>
        <img
          src={uploadIcon}
          alt="Upload Icon"
          className="img-fluid"
          style={{ cursor: "pointer", height: "100px" }}
        />
      </label>
      <input
        className="form-control d-none"
        type="file"
        id="jsonFile"
        accept="image/*"
        onChange={onFileUpload}
      />
    </div>
  );
};

export default ImageUpload;